<template>
    <div>
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav/>
            </div>
        </el-header>
        <el-main class="about">
            <div class="contBox" id="contBox">
                <h3>公司简介</h3>
                <el-divider class="fg"></el-divider>
                <p class="text">
                    二十年来，我们始终专注于专业级无线通信技术的自主研发。在不断突破现有技术指标极限的基础上，持续迭代MANET技术体制，目前，公司拥有完全自主知识产权的适用于各个领域的多种MANET无线自组网波形系列。通过将高效、安全、去中心的自主互连通信技术及产品提供给广大客户，让用户因为强大的中国智造而拥有了迅捷、高效、平滑的语音、数据、视频及可视化指挥调度等综合业务能力，真正实现在各种需求场景下，“随时随地、随心互连”。
                </p>
                <p class="text">和峰科技，愿携手各界合作伙伴，并肩共创无线智连的美好新时代。</p> <!--向世界提供最强中国自组网技术，-->
                <img src="../assets/images/top.jpg" alt="">
            </div>
        </el-main>
        <el-footer class="footer">
            <hq-footer/>
        </el-footer>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";

    export default {
        name: "AboutHQ",
        methods:{
            setHeight(){
                let bodyH = document.body.clientHeight;
                let windowH = document.documentElement.clientHeight;
                let div = document.getElementById('contBox');
                div.style.minHeight = ((windowH - bodyH) + 447) + "px";
            },
        },
        mounted() {
            this.setHeight();
        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer,
        }
    }
</script>

<style scoped>
    .footer{
        position: fixed;
        bottom: 0;
        right: 0;
    }
    .about{
        background: #000000;
    }
    .about img{
        width: 100%;
        height: auto;
    }
    .about h3{
        font-family: AlibabaPuHuiTi-Heavy;
        font-size: 3.35rem;
        color: #ffffff;
        margin: 1rem 0;
        text-align: left;
    }
    .about .text {
        font-family: AlibabaPuhuiTiR;
        font-size: 1.5rem;
        color: #fff;
        line-height: 2.75rem;
        margin: 2rem 0;
        text-align: left;
    }
    .fg{
        width: 6.125rem;
        height: 2px;
        color: #dd3010;
    }
</style>
